import { connect } from 'react-redux'
import { CoveragePlan } from './components'
import { hasProductSelected } from 'quick-quote/selectors/selected-display-product'

const mapStateToProps = (state) => ({
  hasProductSelected: hasProductSelected(state),
})

const mapDispatchToProps = (dispatch) => ({})

export const CoveragePlanContainer = connect(mapStateToProps, mapDispatchToProps)(CoveragePlan)
